<template>
  <table class="ui-table">
    <thead class="ui-table__header">
      <tr>
        <th v-if="selectable" class="ui-table__colHeader">
          <div class="ui-table__checkbox">
            <el-checkbox v-model="isAllChecked" @change="toggleRowCheckedAll"></el-checkbox>
          </div>
        </th>
        <th
          v-for="(colOptions, colName) in cols"
          :key="colName"
          class="ui-table__colHeader"
          :class="{'ui-table__colHeader--sortable':colOptions.sortable}"
          @click="colOptions.sortable && toggleSort(typeof colOptions.sortable === 'string'?colOptions.sortable:colName)"
          :style="colOptions.styles || {}"
        >
          <div class="ui-table__colHeader__container">
            <div>{{colOptions.label || ''}}</div>
            <div v-if="colOptions.sortable" class="ui-table__colSort">
              <ui-inline-icon
                class="ui-table__colSort__up"
                icon="filledarrow-up"
                :height="6"
                :color="sort[typeof colOptions.sortable === 'string'?colOptions.sortable:colName]===1?'#1989FA':''"
              ></ui-inline-icon>
              <ui-inline-icon
                class="ui-table__colSort__down"
                icon="filledarrow-up"
                :height="6"
                :color="sort[typeof colOptions.sortable === 'string'?colOptions.sortable:colName]===-1?'#1989FA':''"
              ></ui-inline-icon>
            </div>
          </div>
        </th>
      </tr>
    </thead>
    <tbody class="ui-table__body">
      <template v-for="(row,rowIndex) in data">
        <tr
          class="ui-table__row"
          :class="{'ui-table__row--toggled':toggled.indexOf(rowIndex)!==-1}"
          :key="rowIndex"
        >
          <td v-if="selectable" class="ui-table__col">
            <div class="ui-table__checkbox">
              <el-checkbox
                v-if="dataMap[row[rowKey]]"
                v-model="dataMap[row[rowKey]].checked"
                @change="onRowChecked(row[rowKey])"
              ></el-checkbox>
            </div>
          </td>
          <td
            v-for="(colOptions, colName) in cols"
            class="ui-table__col"
            :key="colName"
            @click="onRowClick({row,rowIndex,colName, toggleRowDetail})"
            :style="colOptions.styles || {}"
          >
            <slot :name="colName" :row="row" :value="row[colName]">
              <component
                v-if="colOptions.component"
                :is="colOptions.component"
                :row="row"
                :rowIndex="rowIndex"
                :colName="colName"
                :value="row[colName]"
                :scope="scope"
                :toggleRowDetail="toggleRowDetail"
              ></component>
              <template v-else-if="colOptions.isModel">{{row.data[colName] || '-'}}</template>
              <template v-else-if="colOptions.isInStud">{{row.data.stud[colName] || row.data[colName] || '-'}}</template>
              <template v-else>{{row[colName]}}</template>
            </slot>
          </td>
        </tr>
        <tr
          class="ui-table__row_detail"
          :class="{'ui-table__row_detail--toggled':toggled.indexOf(rowIndex)!==-1}"
          v-if="detailRowComponent"
          :key="rowIndex+'-detail'"
        >
          <td :colspan="100">
            <ui-transition name="collapse">
              <div class="ui-table__row_detail__inner" v-if="toggled.indexOf(rowIndex)!==-1">
                <component
                  :is="detailRowComponent"
                  :row="row"
                  :rowIndex="rowIndex"
                  :toggleRowDetail="toggleRowDetail"
                  :scope="scope"
                ></component>
              </div>
            </ui-transition>
          </td>
        </tr>
      </template>
      <template v-if="!data.length">
        <tr class="ui-table__row ui-table__row--no-data">
          <td class="ui-table__col" colspan="100">{{ $t('labels.no_data') }}</td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
  import _ from 'lodash'
  export default {
    name: 'UiTable',
    props: {
      sort: {},
      scope: {},
      cols: {
        type: Object,
        default () {
          return {}
        }
      },
      detailRowComponent: {
        type: Function
      },
      data: {
        type: Array,
        default () {
          return []
        }
      },
      selectable: Boolean,
      rowKey: {type: String, default: 'id'},
      defaultCheckedKeys: {
        type: Array,
        default () {
          return []
        }
      }
    },
    data () {
      return {
        toggled: [],
        checkedKeys: [],
        dataMap: {}
      }
    },
    computed: {
      isAllChecked: {
        get () {
          let isAllChecked = true;
          for (let item of this.data) {
            if (!this.dataMap[item[this.rowKey]].checked) {
              isAllChecked = false;
            }
          }
          return isAllChecked;
        },
        set () {}
      }
    },
    methods: {
      toggleSort (colName) {
        this.$emit('toggleSort', colName)
      },
      onRowClick (event) {
        this.$emit('rowClick', event)
      },
      toggleRowDetail (rowIndex) {
        if (this.toggled.indexOf(rowIndex) === -1) {
          this.toggled.push(rowIndex)
        } else {
          this.toggled.splice(this.toggled.indexOf(rowIndex), 1)
        }
      },
      onRowChecked (key) {
        let index = this.checkedKeys.indexOf(key)
        if (index >= 0) {
          this.checkedKeys.splice(index, 1);
        } else {
          this.checkedKeys.push(key)
        }
        this.onInput()
      },
      toggleRowCheckedAll () {
        const isAllChecked = this.isAllChecked;
        for (const item of this.data) {
          if (isAllChecked) {
            this.checkedKeys = []
          } else {
            if (this.checkedKeys.indexOf(item[this.rowKey]) < 0) {
              this.checkedKeys.push(item[this.rowKey])
            }
          }
          this.dataMap[item[this.rowKey]].checked = !isAllChecked
        }
        this.onInput()
      },
      onInput () {
        let checkedRows = []
        for (let key of this.checkedKeys) {
          if (this.dataMap[key]) {
            checkedRows.push(this.dataMap[key].data)
          }
        }
        this.$emit('onRowChecked', checkedRows)
      },
      createDataMap () {
        if (this.data.length) {
          for (const item of this.data) {
            if (!this.dataMap[item[this.rowKey]]) {
              let isChecked = this.defaultCheckedKeys.indexOf(item[this.rowKey]);
              this.$set(this.dataMap, item[this.rowKey], {
                checked: isChecked >= 0,
                data: item
              })
              if (isChecked >= 0) {
                // this.checkedKeys.push(item[this.rowKey])
              }
            }
          }
        }
      },
      setDefaultCheckedKeys () {
        this.checkedKeys = _.cloneDeep(this.defaultCheckedKeys)
        if (this.defaultCheckedKeys.length) {
          for (let key of this.defaultCheckedKeys) {
            if (this.dataMap[key]) {
              this.dataMap[key].checked = true;
            }
          }
        }
      },
      setCheckedKeys (keys) {

      },
      unsetCheckedKeys (keys) {
        for (let key of keys) {
          if (this.dataMap[key]) {
            this.dataMap[key].checked = false;

            let i = this.checkedKeys.indexOf(key)
            if (i >= 0) {
              this.checkedKeys.splice(i, 1)
            }
          }
        }
      }
    },
    mounted () {
      this.createDataMap()
      this.setDefaultCheckedKeys()
    },
    watch: {
      data () {
        this.createDataMap()
      },
      defaultCheckedKeys (newVal, oldVal) {
        let diffKeys = _.difference(oldVal, newVal);
        this.unsetCheckedKeys(diffKeys)
        this.setDefaultCheckedKeys()
      }
    }
  }
</script>

<style lang="scss">
  .ui-table {
    background: #ffffff;
    box-shadow: 0px 5px 25px rgba(0, 0, 0, 0.05);
    border-radius: 3px;
    width: 100%;

    &__header {
      border-bottom: 1px solid #e4e7ed;
    }

    &__colHeader {
      padding: 15px 5px 14px;
      font-size: 14px;
      color: #909399;
      font-weight: 400;

      &__container {
        display: flex;
        align-items: center;
      }

      &:first-child {
        padding-left: 30px;
      }

      &--sortable {
        cursor: pointer;
        user-select: none;
      }
    }

    &__colSort {
      display: flex;
      flex-direction: column;
      height: 100%;
      margin-left: 10px;

      &__up,
      &__down {
        line-height: 1px;
      }

      &__down {
        svg {
          transform: rotate(180deg);
        }
      }
    }

    &__col {
      padding: 15px 5px 14px;
      vertical-align: middle;

      &:first-child {
        padding-left: 30px;
      }
      &:last-child {
        padding-right: 30px;
      }
    }

    &__row {
      border-top: 1px solid #e4e7ed;
      > td {
        transition: background-color ease 0.24s;
      }
      &:hover {
        > td {
          background-color: #f5f7fa;
        }
      }

      &:first-child {
        border-top: 0;
      }

      &--no-data {
        &:hover {
          td {
            cursor: default;
            background-color: transparent;
          }
        }
        td {
          text-align: center;
          color: #909399;
        }
      }
    }

    &__row_detail {
      border-bottom: 1px solid #e4e7ed;
    }

    &__checkbox {
      .el-checkbox {
        margin-bottom: 0;
      }
    }
  }
</style>